/* src/app/system-message/system-message.component.scss */
.system-message {
  background-color: #FFD100;
  width: 100%;
  min-height: 42px;
  font-size: 14px;
  font-weight: 700;
  display: grid;
  align-items: center;
  grid-template-columns: 15px [page-number] max-content 6px [message] auto [close] min-content 15px;
}
@media screen and (min-width: 768px) {
  .system-message {
    grid-template-columns: 36px [page-number] max-content 9px [message] auto [close] min-content 40px;
  }
}
@media screen and (min-width: 1880px) {
  .system-message {
    grid-template-columns: 250px [page-number] max-content 60px [message] auto [close] min-content 280px;
  }
}
.message-number {
  font-size: 19px;
  font-weight: 400;
  margin-left: 3px;
  margin-right: 3px;
  white-space: nowrap;
}
@media screen and (min-width: 768px) {
  .message-number {
    margin-left: 5px;
    margin-right: 5px;
  }
}
@media screen and (min-width: 1880px) {
  .message-number {
    margin-left: 30px;
    margin-right: 30px;
  }
}
/*# sourceMappingURL=system-message.component.css.map */
